import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import moment from 'moment';
import { toast } from 'react-toastify'
import FontAwesome from 'react-fontawesome'
import Box from '../components/Layout/Box'
import BoxButton from '../components/Layout/BoxButton'
import ButtonStrip from '../components/Layout/ButtonStrip'
import BoxSection from '../components/Layout/BoxSection'
import ModalAddFile from '../components/Shared/ModalAddFile'
import ModalSelectorFromList from '../components/Shared/ModalSelectorFromList'
import { removeSolicitudServicioFiles } from '../actions/creacionsolicitudservicioot'
import SelectorInput from '../components/Shared/SelectorInput'
import AttachedFilesBox from '../components/Shared/AttachedFilesBox'




import {
    showModalSelector,
    selectFromSelector
} from '../actions/common'


import {
    updateInputs,
    addAlojamiento,
    removeAlojamientos,
    createSolicitudHoteles,
    addHuesped,
    addCencoSolicitud,
    removeCenco,
    addForoComentario,
    editarForoComentario,
    removeForoComentario,
    enviarComentario,
    editarComentario,
    eliminarComentario,
    addFile,
    removeSolicitudHotelesFiles
} from '../actions/creacionsolicitudhoteles'

class CreacionSolicitudHoteles extends Component {


    handleOpenSelector = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES', payload)
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/cencos', fn)
    }


    handleOpenSelectorAddCenco = (list, index) => {
        let columns = [
            { id: 1, caption: 'Codigo', value: 'codigo', width: '30%' },
            { id: 2, caption: 'Descripcion', value: 'descripcion', width: '70%' }
		]
        const payload = {}
        const fn = (a) => {
            const index = this.props.creacionsolicitudhoteles.get('cencos').findIndex(c => c.getIn(['cenco', 'id']) == a.id)
            if (index >= 0) {
                toast.warn(`El cenco ${a.codigo} ya se encuentra en el listado`, { bodyClassName: 'toastify-content toastify-warning' })
            } else {
                payload.path = list
                payload.value = a
                this.props.selectFromSelector('MODIFICAR_INPUTS_SOLICITUD_HOTELES', payload)
            }
        }
        const customFilter = { column: 'T0.responsable_id', operator: '===', value: this.props.creacionsolicitudhoteles.getIn(['cencos', index, 'responsable', 'id']), comparison: 'string' }
        this.props.showModalSelector('Listado de CENCOS', columns, '/cencos', fn, customFilter)
	}


    handleOpenSelectorAddHuesped = (path) => {
        let columns = [
            { id: 1, caption: 'Identificacion', value: 'username', width: '30%' },
            { id: 2, caption: 'Nombre', value: 'fullname', width: '70%' }
        ]
        const payload = {}
        const fn = (a) => {
            payload.path = path
            payload.value = a
            this.props.selectFromSelector(() => this.props.addHuesped(payload))
        }
        this.props.showModalSelector('Listado de usuarios', columns, '/usuarios/ldap', fn)
    }


	render() {

        const { creacionsolicitudhoteles, enums } = this.props

        const tipos_identificacion = enums.tipos_identificacion

        const boxActions = [
            <BoxButton key="ba[0][1]" name="floppy-o" onClick={ () => this.props.createSolicitudHoteles() } title="Guardar"  />,
        ]

        // const accionesAlojamientos = [
        //     <BoxButton key="ba[1][0]" size={14} contrast name="plus-circle" title="Adicionar alojamiento" onClick={ () => this.props.addAlojamiento() }  disabled/>,
        //     <BoxButton key="ba[1][1]" size={14} contrast name="trash" title="Eliminar alojamiento" onClick={ () => this.props.removeAlojamientos() } danger disabled />,
        // ]


        const actionsDistribucionCencos = [
            <BoxButton key="ba[2][0]" size={14} contrast name="plus-circle" title="Nuevo" onClick={ () => this.props.addCencoSolicitud() } />,
            <BoxButton key="ba[2][1]" size={14} contrast name="trash" title="Eliminar" onClick={ () => this.props.removeCenco() } danger />,
        ]


		return (
            <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                <div className="col-md-12" style={{ height: '100%' }}>

                    <div className="separator"></div>

                    <Box title="Solicitud de hoteles > Creación">

                        <ButtonStrip actions={ boxActions } />

                        <div className="box-content">

                            <Fragment>

                                <BoxSection title="Información básica">

                                <div className="row">

                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Solicitante</label>
                                                <input type="text" value={this.props.user.get('fullname') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input type="text" value={this.props.user.get('email') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input type="text" value={this.props.user.get('extension') || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>


                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Área</label>
                                                <input type="text" value={this.props.user.getIn(['area', 'nombre']) || ''} className="form-control input-sm" disabled />
                                            </div>
                                        </div>

                                    </div>


                                    <div className="row">
                                        <div className="col-md-5">
                                            <div className="form-group">
                                                <label className="control-label">Responsable de compras</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.fullname || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-3">
                                            <div className="form-group">
                                                <label className="control-label">Correo</label>
                                                <input className="form-control input-sm" value={enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.email || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-1">
                                            <div className="form-group">
                                                <label className="control-label">Extensión</label>
                                                <input className="form-control input-sm" type="text" value={enums.solicitudes.tipos[creacionsolicitudhoteles.get('tipo')].responsable.extension || ''} disabled />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Fecha de solicitud</label>
                                                <input className="form-control input-sm" value={moment().format('YYYY/MM/DD')} disabled />
                                            </div>
                                        </div>

                                    </div>

                                </BoxSection>


                                <div className="separator"></div>


                                <BoxSection title="Información hospedaje">

                                    <div className="row">

                                        <div className="col-md-10">
                                            <div className="form-group">
                                                <label className="control-label">Motivo del hospedaje</label>
                                                <input className="form-control input-sm" type="text" value={ creacionsolicitudhoteles.get('motivo_hospedaje') || ''  } onChange={ e => this.props.updateInputs('motivo_hospedaje', e.target.value) } />
                                            </div>
                                        </div>

                                        <div className="col-md-2">
                                            <div className="form-group">
                                                <label className="control-label">Cantidad huéspedes</label>
                                                <input className="form-control input-sm" type="number" min="1" max="9" value={ creacionsolicitudhoteles.get('cant_huespedes') || '' } onChange={ e => this.props.updateInputs('cant_huespedes', e.target.value)}/>
                                            </div>
                                        </div>


                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Detalles de alojamiento">

                                    <table className="table table-condensed table-bordered table-striped table-sorted nowrap" id="table-alojamientos">
                                        <thead>
                                            <tr>
                                                <th width="20px">
                                                    <input type="checkbox" style={{ verticalAlign: 'middle' }}  />
                                                </th>
                                                <th>Ciudad</th>
                                                <th style={{ width: '15%' }}>Fecha ingreso</th>
                                                <th style={{ width: '15%' }}>Fecha salida</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {creacionsolicitudhoteles.get('alojamientos').map((t,i) => {

                                                return (
                                                    <tr key={ t.get('guid') } className={ t.get('selected') ? 'info' : '' }>
                                                        <td><input type="checkbox" style={{ verticalAlign: 'middle' }} value={ t.get('selected') } onChange={ e => this.props.updateInputs(`alojamientos.${i}.selected`, e.target.value)} disabled={i==0} /></td>
                                                        <td>
                                                            <input className="form-control input-sm" type="text" value={ t.get('ciudad') || '' } onChange={ e => this.props.updateInputs(`alojamientos.${i}.ciudad`, e.target.value)} />
                                                        </td>
                                                        <td><input className="form-control input-sm" type="date" value={ t.get('fecha_ingreso') || '' } onChange={ e => this.props.updateInputs(`alojamientos.${i}.fecha_ingreso`, e.target.value)} /></td>
                                                        <td><input className="form-control input-sm" type="date" value={ t.get('fecha_salida') || '' } onChange={ e => this.props.updateInputs(`alojamientos.${i}.fecha_salida`, e.target.value)} /></td>
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>

                                    {creacionsolicitudhoteles.get('alojamientos').map((t,i) => {

                                        return (
                                            <table className="table nowrap" key={`${t.get('id')}-${i}`}>
                                                <tbody>
                                                    <tr>
                                                        <td style={{width : '182px'}}> <div style={{ display: 'flex' , alignItems: 'center'}}> <label> Consumo a la habitación </label> <input type="checkbox"  className="form-control input-sm" value={t.get('consumo_habitacion')} onChange={ e => this.props.updateInputs(`alojamientos.${i}.consumo_habitacion`, e.target.checked)}/>  </div></td>
                                                        <td> <div style={{ display: 'flex' , alignItems: 'center'}}> <label> Monto de consumo </label> <input type="text"  className="form-control input-sm" style={{ marginLeft : '5px' , width: '100px'}} value={ t.get('monto_consumo') || '' } onChange={ e => this.props.updateInputs(`alojamientos.${i}.monto_consumo`, e.target.value)} disabled={!t.get('consumo_habitacion')} /> </div></td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        )
                                    })}
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Distribución de centros de costos" actions={actionsDistribucionCencos}>
                                    <div className="box-content" >
                                        <table className="table table-condensed">
                                            <thead>
                                                <tr>
                                                    <th style={{ width: '20px' }} ></th>
                                                    <th>Ordenador del gasto</th>
                                                    <th>Centro de costo</th>
                                                    <th>Porcentaje</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>

                                            {
                                                creacionsolicitudhoteles.get('cencos').count() > 0 ? (creacionsolicitudhoteles.get('cencos').map((x, n) => {
                                                    return (
                                                        <tr key={ `tr[${ x.get('id') ? x.get('id') : x.get('guid') }]` }  className={ x.get('selected') ? 'info-dark' : '' } >
                                                            <td ><input type="checkbox" style={{ marginTop: '6px' }} checked={ x.get('selected') || false } onChange={ (e) => this.props.updateInputs(`cencos.${n}.selected`, e.target.checked) } /></td>
                                                            <td>
                                                                <SelectorInput value={ x.getIn(['responsable', 'fullname']) || '' } onClick={ () => this.handleOpenSelector(`cencos.${n}.responsable`) } onReset={ () => this.props.updateInputs(`cencos.${n}.responsable`, null) } />
                                                            </td>
                                                            <td>
                                                                {
                                                                    x.get('responsable') ? (
                                                                        <SelectorInput value={ x.get('cenco') ? x.getIn(['cenco','codigo']) : '' } onClick={ () => this.handleOpenSelectorAddCenco(`cencos.${n}.cenco`, n) } onReset={ () => this.props.updateInputs(`cencos.${n}.cenco`, null) }/>
                                                                    ) : (
                                                                        <input className="form-control input-sm" placeholder="Seleccione un responsable del cenco" disabled />
                                                                    )
                                                                }
                                                            </td>
                                                            <td>
                                                                <input type="number" className="form-control input-sm" placeholder="Porcentaje" value={ x.get('porcentaje') ? x.get('porcentaje') : 0 }  onChange={ (e) => this.props.updateInputs(`cencos.${n}.porcentaje`, e.target.value) } disabled={ x.get('responsable') == null } />
                                                            </td>
                                                            <td style={{ width: '20px', verticalAlign: 'middle' }}>%</td>
                                                        </tr>
                                                    )
                                                })) : (
                                                        <tr>
                                                            <td colSpan={6} style={{ textAlign: 'center' }}>
                                                                Para agregar un centro de costo haga click en el botón <span style={{ color: '#888' }}><FontAwesome name="plus-circle" /></span>
                                                            </td>
                                                        </tr>
                                                )
                                            }
                                            </tbody>
                                        </table>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <BoxSection title="Observaciones">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="form-group">
                                                <textarea type="text" className="form-control input-sm" rows={4} value={ creacionsolicitudhoteles.get('observaciones') || '' } onChange={ (e) => this.props.updateInputs('observaciones', e.target.value) } />
                                            </div>
                                        </div>
                                    </div>
                                </BoxSection>

                                <div className="separator"></div>

                                <AttachedFilesBox
                                    files={ creacionsolicitudhoteles.get('adjuntos') }
                                    removeFiles = { this.props.removeSolicitudHotelesFiles }
                                    updateInputs = { this.props.updateInputs }
                                    obj={ creacionsolicitudhoteles }
                                    check={ 'solicitud' }
                                />

                                <div className="separator"></div>

                                <BoxSection title="Huéspedes">

                                {creacionsolicitudhoteles.get('huespedes').map((p,i) => {

                                    return (

                                        <Fragment key={ `Fragment[${i}]` }>

                                            <div className="separator"></div>

                                            <Box title={ `Huésped #${i+1}` }>

                                                <Box title={ 'Información del huésped' } onModal>

                                                    <div className="separator"></div>

                                                    <div className="row">

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">Tipo huésped</label>
                                                                <select className="form-control input-sm" value={p.get('tipo_huesped')} onChange={ e => this.props.updateInputs(`huespedes.${i}.tipo_huesped`, e.target.value)}>
                                                                    <option value="1">Empleado</option>
                                                                    <option value="2">Invitado</option>
                                                                </select>
                                                            </div>
                                                        </div>

                                                        {
                                                            (p.get('tipo_huesped') == 1) ? (
                                                            <Fragment>
                                                                <div className="col-md-4">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Nombre completo</label>
                                                                        <SelectorInput value={ p.get('fullname') ? p.get('fullname') : '' } onClick={ () => this.handleOpenSelectorAddHuesped(`huespedes.${i}`) } onReset={ () => this.props.updateInputs(`huespedes.${i}`, { selected: p.get('selected'), guid: p.get('guid') }) } />
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            ) : (
                                                            <Fragment>
                                                                <div className="col-md-2">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Nombres</label>
                                                                        <input className="form-control input-sm" type="text" value={ p.get('nombres') || '' } onChange={ e => this.props.updateInputs(`huespedes.${i}.nombres`, e.target.value)} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <div className="form-group">
                                                                        <label className="control-label">Apellidos</label>
                                                                        <input className="form-control input-sm" type="text" value={ p.get('apellidos') || '' } onChange={ e => this.props.updateInputs(`huespedes.${i}.apellidos`, e.target.value)} />
                                                                    </div>
                                                                </div>
                                                            </Fragment>
                                                            )
                                                        }

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">Tipo de documento</label>
                                                                <select className="form-control input-sm" value={ p.get('tipo_documento') || 1 } onChange={ (e) => this.props.updateInputs(`huespedes.${i}.tipo_documento`, e.target.value) }>
                                                                {
                                                                    Object.keys(tipos_identificacion).map((key, ikey) => {
                                                                        return (
                                                                            <option key={`opt[${i}][${ikey}]`} value={key}>{ tipos_identificacion[key] }</option>
                                                                        )
                                                                    })
                                                                }
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">No. de Documento</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('numero_documento') || '' } onChange={ e => this.props.updateInputs(`huespedes.${i}.numero_documento`, e.target.value)} />
                                                            </div>
                                                        </div>


                                                        <div className="col-md-2">
                                                            <div className="form-group">
                                                                <label className="control-label">Celular</label>
                                                                <input className="form-control input-sm" type="text" value={ p.get('celular') || '' } onChange={ e => this.props.updateInputs(`huespedes.${i}.celular`, e.target.value)} />
                                                            </div>
                                                        </div>


                                                    </div>

                                                </Box>

                                            </Box>

                                        </Fragment>

                                    )
                                })}

                                </BoxSection>

                                <div className="separator"></div>

                                <ModalAddFile
                                    action={() => this.props.addFile() }
                                />



                            </Fragment>

                        </div>


                    </Box>

                </div>

                <ModalSelectorFromList />




            </div>
		)
	}
}

function mapStateToProps(state) {
    return {
        user: state.common.get('user'),
        creacionsolicitudhoteles: state.creacionsolicitudhoteles,
        enums: state.common.get('enums').toJS(),
        responsable: state.common.getIn(['parametros', 'SOLICITUDES']) ? state.common.getIn(['parametros', 'SOLICITUDES']).filter(x => x.get('TIPO_SOLICITUD') == state.creacionsolicitudhoteles.get('tipo')).first() : null
    }
}

function mapDispatchToProps(dispatch) {
    return {
        updateInputs: (path, value) => dispatch(updateInputs(path, value)),
        addAlojamiento: () => dispatch(addAlojamiento()),
        removeAlojamientos: () => dispatch(removeAlojamientos()),
        createSolicitudHoteles: () => dispatch(createSolicitudHoteles()),
        addHuesped: (path) => dispatch(addHuesped(path)),
        removeSolicitudServicioFiles: () => dispatch(removeSolicitudServicioFiles()),
        showModalSelector: (title, fields, url, action, customFilter) => dispatch(showModalSelector(title, fields, url, action, customFilter)),
        selectFromSelector: (type, payload) => dispatch(selectFromSelector(type, payload)),
        addCencoSolicitud: () => dispatch(addCencoSolicitud()),
        removeCenco: () => dispatch(removeCenco()),
        enviarComentario: () => dispatch(enviarComentario()),
        eliminarComentario: (guid) => dispatch(eliminarComentario(guid)),
        editarComentario: (guid) => dispatch(editarComentario(guid)),
        addFile : () => dispatch(addFile()),
        removeSolicitudHotelesFiles: () => dispatch(removeSolicitudHotelesFiles())
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(CreacionSolicitudHoteles)



// WEBPACK FOOTER //
// ./src/containers/CreacionSolicitudHoteles.jsx